import { useMemo } from "react";

export function isEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (typeof a !== typeof b) return false;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((val, i) => isEqual(val, b[i]));
  }

  if (typeof a === "object") {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    return keysA.every((key) => isEqual(a[key], b[key]));
  }

  return String(a) === String(b);
}

export function useHasChanges(current, original) {
  return useMemo(() => {
    if (current === undefined || original === undefined) {
      return current !== original;
    }
    return !isEqual(current, original);
  }, [current, original]);
}
